import { useGetProgramSummary } from '../api/useProgram';
import { SummaryCard } from './SummaryCard';

export const ProgramSummaryCards = ({ uid }: { uid: string }) => {
  const { data, isLoading, isError } = useGetProgramSummary(uid);
  const s = data?.payload?.summary;

  if (isError) return null;

  return (
    <div className="flex flex-wrap gap-4">
      <SummaryCard label="Sales" value={s?.sales ?? '—'} loading={isLoading} />
      <SummaryCard label="Vendor earnings" value={s?.vendor_earnings ?? '—'} loading={isLoading} />
      <SummaryCard label="Net revenue" value={s?.net_revenue ?? '—'} loading={isLoading} />
      <SummaryCard label="Members balance" value={s?.members_balance ?? '—'} loading={isLoading} />
    </div>
  );
};
